import { render, staticRenderFns } from "./SpcGiveawayGraph.vue?vue&type=template&id=06c3ad8e&scoped=true"
import script from "./SpcGiveawayGraph.vue?vue&type=script&lang=js"
export * from "./SpcGiveawayGraph.vue?vue&type=script&lang=js"
import style0 from "./SpcGiveawayGraph.vue?vue&type=style&index=0&id=06c3ad8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3ad8e",
  null
  
)

export default component.exports